import Form, { InputType } from '../../lib/Formik';
import en from '../../lang/en-us';
import { FormikHelpers, useFormik } from 'formik';
import { connect } from 'react-redux';
import { OTP_ACTIONS } from '../../utils/constants';
import {
    getOtpForgotPassword,
    verifyOtpForgotPassword,
    onResendLoginOTP,
} from '../../redux-store/actions/login';
import { useEffect, useMemo, useState } from 'react';
import { OtpField, ResendOtp, useTimer } from '../../lib/OtpField';
import { ForgotPasswordOtpVerify } from '../../redux-store/types/login';

const {
    forgotPassword,
    common,
    login: { form },
} = en;

const initOTPInfo = {
    reqId: '',
    otpRef: '',
};

const formFields: Partial<InputType>[] = [
    {
        label: forgotPassword.label,
        name: 'userId',
        type: 'text',
        disabled: true,
    },
    {
        component: OtpField,
        name: 'otp',
    },
];

const initialValues = {
    otp: new Array(6).fill(''),
};

function ForgotPasswordOTP(props: any) {
    const { userId = '', ...rest } = props.location.state || {};
    const { timer, resetTimer, startTimer } = useTimer({ initcounter: 55 });
    const [otpInfo, setOtpInfo] = useState<{ reqId: string; otpRef: string }>(initOTPInfo);
    const onVerify = async (
        values: { otp: string[] },
        action: FormikHelpers<{ otp: string[] }>,
    ) => {
        if (values.otp.join('').length !== 6) {
            // formik.setErrors({otp: 'Please enter otp'});
            alert(common.noOtp);
            action.setSubmitting(false);
            return;
        }
        const payload: ForgotPasswordOtpVerify = {
            ...otpInfo,
            enteredOtp: values.otp.join(''),
            userId,
            action: 'FORGOT_PWD',
        };
        try {
            let res = await props.verifyOtpForgotPassword(payload);
            props.history.push(`forgot-password-questionnaire`, {
                ...rest,
                action: OTP_ACTIONS.forgot_password,
                fromForgotPassword: true,
                ...(res || {}).body,
            });
        } catch (err: any) {
            alert(err.message);
            props.history.goBack();
        }
        action.setSubmitting(false);
    };

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit: onVerify,
    });

    const onResend = async () => {
        try {
            let res = await props.onResendLoginOTP({
                reqId: otpInfo?.reqId || '',
                action: OTP_ACTIONS.forgot_password,
                otpRef: otpInfo?.otpRef || '',
            });
            resetTimer();
            setOtpInfo({ ...(res || {}).body });
            formik.setFieldValue('otp', new Array(6).fill(''));
        } catch (err: any) {
            alert(err.message);
        }
    };

    const _Form = useMemo(() => {
        return <Form ui={formFields} formik={formik} submitButtonLabel="Verify OTP"></Form>;
    }, [formik]);

    useEffect(() => {
        if (!userId) {
            props.history.push('signin');
            return;
        }
        formik.setFieldValue('userId', userId);
        setOtpInfo({ otpRef: rest.otpRef, reqId: rest.reqId });
    }, []);
    return (
        <div className="signup-padding">
            <h4 className="text-center">{forgotPassword.otpAuthentication}</h4>
            <p className="text-center subheading">
                {forgotPassword.otpinfo} Registered Mobile Number
            </p>
            {_Form}
            <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
        </div>
    );
}

export default connect(null, { getOtpForgotPassword, verifyOtpForgotPassword, onResendLoginOTP })(
    ForgotPasswordOTP,
);
